import { createEventBus } from '@/event-bus';

export const nodeViewEventBus = createEventBus();
